/*
 * Smooth Scroll — Lenis-powered inertia scrolling
 * Mirrors the GSAP ScrollSmoother effect (smooth: 2) from proweb.gr
 * Uses Lenis (open-source) for the same buttery lerp-based scroll
 */
(function () {
  // Skip on Shopify theme editor to avoid conflicts
  if (window.Shopify && window.Shopify.designMode) return;

  // Respect reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Load Lenis from CDN
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/lenis@1/dist/lenis.min.js';
  script.onload = initSmoothScroll;
  document.head.appendChild(script);

  // Load Lenis CSS (required for proper html.lenis styling)
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/lenis@1/dist/lenis.min.css';
  document.head.appendChild(link);

  function initSmoothScroll() {
    // Footer brake zone — cache the footer element and its position
    var footerEl = null;
    var footerTop = 0;
    var brakeZone = 600;   // pixels above the footer where braking begins
    var minFactor = 0.2;   // minimum scroll speed at the footer edge (20% of normal)

    function getFooterTop() {
      if (!footerEl) footerEl = document.querySelector('footer.footer');
      if (footerEl) footerTop = footerEl.getBoundingClientRect().top + window.scrollY;
      return footerTop;
    }

    // Recalculate on resize / layout shifts
    window.addEventListener('resize', function () { footerTop = 0; });

    var lenis = new Lenis({
      duration: 0.4,        // scroll duration in seconds — subtle smoothness without long coast
      easing: function (t) {
        // Quintic ease-out: aggressive deceleration for quick stop
        return 1 - Math.pow(1 - t, 5);
      },
      smoothWheel: true,     // smooth scrolling for mouse wheel
      smoothTouch: false,    // keep native touch scrolling on mobile (better UX)
      touchMultiplier: 1.5,  // touch scroll speed multiplier

      // Momentum brake — progressively reduce scroll delta near the footer
      virtualScroll: function (e) {
        // Only brake downward scrolls
        if (e.deltaY <= 0) return;

        var ft = getFooterTop();
        if (!ft) return;

        var brakeStart = ft - brakeZone;
        var scrollPos = lenis.targetScroll + window.innerHeight;

        if (scrollPos > brakeStart) {
          // 1 at brake zone entry → 0 at footer edge
          var progress = Math.min((scrollPos - brakeStart) / brakeZone, 1);
          // Quadratic ramp: gentle at first, firm near footer
          var factor = 1 - progress;
          factor = factor * factor;
          // Clamp to minimum so scroll doesn't completely freeze
          factor = Math.max(factor, minFactor);
          e.deltaY *= factor;
        }
      },
    });

    // Animation loop — drives the lerp interpolation
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Expose globally so other scripts can interact with it
    window.lenisInstance = lenis;

    // Pause smooth scroll when cart drawer or modals are open
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var body = document.body;
          var isOverflowHidden =
            body.classList.contains('overflow-hidden') ||
            body.classList.contains('cart-drawer--open') ||
            getComputedStyle(body).overflow === 'hidden';

          if (isOverflowHidden) {
            lenis.stop();
          } else {
            lenis.start();
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    // Handle anchor link clicks for smooth scroll to sections
    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: 0 });
      }
    });
  }
})();
